import React from 'react';
import { Link } from 'react-router-dom';
import Imageone from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/1.jpg";
import Imagetwo from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/2.jpg";
import Imagethree from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/3.jpg";
import Imagefour from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/4.jpg";
import Imagefive from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/5.jpg";
import Imagesix from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/6.jpg";
import Imageseven from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/7.jpg";
import Imageeight from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/8.jpg";
import Imagenine from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/9.jpg";
import Imageten from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/10.jpg";
import Imageeleven from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/2. LSAW PIPE/11.jpg";


const tools = [
  { img: Imageone, name: "Drills" },
  { img: Imagetwo, name: "Pneumatic Tools" },
  { img: Imagethree, name: "Angle Grinders" },
  { img: Imagefour, name: "Electric Screwdrivers" },
  { img: Imagefive, name: "Electric Saws" },
  { img: Imagesix, name: "Sanders" },
  { img: Imageseven, name: "Sanders" },
  { img: Imageeight, name: "Sanders" },
  { img: Imagenine, name: "Sanders" },
  { img: Imageten, name: "Sanders" },
  { img: Imageeleven, name: "Sanders" },
];

function Coming() {
  return (
    <div className="py-6">
      <div className="bg-white rounded-xl">
        <div className="mx-auto px-4 py-10 sm:px-10 sm:py-14">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {tools.map((tool, index) => (
              <Link
                key={index}
                to="#"
                className="group block overflow-hidden rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-gray-50"
              >
                <div className="relative">
                  <img
                    src={tool.img}
                    alt={tool.name}
                    className="w-full h-64 object-cover transition-opacity duration-300 rounded-t-2xl"
                  />
                  {/* <div className="px-4 py-3 text-center">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 transition duration-300 tracking-wide">
                      {tool.name}
                    </h3>
                  </div> */}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Coming;
